export default "__VITE_ASSET__COOYfF5D__"